import { render, staticRenderFns } from "./HomeIntro.vue?vue&type=template&id=2bf1ebe2&scoped=true"
import script from "./HomeIntro.vue?vue&type=script&lang=ts"
export * from "./HomeIntro.vue?vue&type=script&lang=ts"
import style0 from "./HomeIntro.vue?vue&type=style&index=0&id=2bf1ebe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf1ebe2",
  null
  
)

export default component.exports